import { TypedDocumentNode, gql } from '@apollo/client';

import { BlogSport } from 'constants/routes';

import { getPostCategory_Post } from './__generated__/postCategory.graphql';

type Post = getPostCategory_Post;

type Category = NonNullable<
  getPostCategory_Post['categories']
>['nodes'][number];

const isBlogSport = (
  category: Category
): category is Category & {
  slug: BlogSport;
} => {
  return ['football', 'nba', 'baseball'].includes(category.slug ?? '');
};

export const getPostCategory = (post: Post): BlogSport | undefined | null => {
  return post.categories?.nodes.find(isBlogSport)?.slug;
};

getPostCategory.fragments = {
  post: gql`
    fragment getPostCategory_Post on Post {
      categories {
        nodes {
          name
          slug
        }
      }
    }
  ` as TypedDocumentNode<getPostCategory_Post>,
};
